export const aboutHotelTemplate = {
  Location: {
    heading:
      '<br /><b style="margin:2px auto 0px;">Location and Easy Accessibility for Guests</b><br />',
    cat_text:
      'The property’s location is highly rated by {Location_per}% of guests, making it a preferred destination for travelers seeking convenience and comfort.<br />',
    sub_catg_text: {
      'easy-to-locate':
        '{Location_easy-to-locate_per}% of guests found the property easy to locate, ensuring a smooth and effortless check-in experience for a comfortable start to their stay.<br />',
      'clean-surroundings':
        'The property is surrounded by fresh and clean surroundings, with {Location_clean-surroundings_per}% of guests appreciating the well-maintained environment.<br />',
      'easily-accessible':
        '{Location_easily-accessible_per}% of guests find the property easily accessible, ensuring a hassle-free stay.<br />',
    },
  },
  Cleanliness: {
    heading: '<br /><b style="margin:2px auto 0px;">Safety & Hygiene for  a Safe Stay</b><br />',
    cat_text:
      'We prioritize safety and cleanliness, earning a cleanliness score of {Cleanliness_per}%.<br />',
    sub_catg_text: {
      'thermal-screening':
        '{Cleanliness_thermal-screening_per}% of guests appreciated our thermal screening measures for added safety.<br />',
      'staff-hygiene':
        'Our staff maintains excellent hygiene, with {Cleanliness_staff-hygiene_per}% of guests noticing their cleanliness and professionalism.<br />',
      'social-distancing':
        'We follow strict social distancing measures, and {Cleanliness_social-distancing_per}% of guests value our commitment to their safety.<br />',
    },
  },
  'Service Quality': {
    heading:
      '<br /><b style="margin:2px auto 0px;">Excellent Service for a Comfortable Stay</b><br />',
    cat_text:
      'Our service quality stands out, with {Service Quality_per}% of guests having a great experience.<br />',
    sub_catg_text: {
      'room-service':
        '{Service Quality_room-service_per}% of guests praised the quick and efficient room service.<br />',
      'reception-area':
        'Our welcoming reception area is appreciated by {Service Quality_reception-area_per}% of guests.<br />',
      'laundry-service':
        'Our laundry service is well-rated, with {Service Quality_laundry-service_per}% of guests finding it convenient and efficient.<br />',
    },
  },
  Food: {
    heading:
      '<br /><b style="margin:2px auto 0px;">Delicious Food for a Great Experience</b><br />',
    cat_text:
      'A satisfying {Food_per}% of guests enjoyed the food, highlighting its taste and variety.<br />',
    sub_catg_text: {},
  },
  Amenities: {
    heading:
      '<br /><b style="margin:2px auto 0px;">Modern Amenities for a Comfortable Stay</b><br />',
    cat_text:
      'The property offers great facilities, with {Amenities_per}% of guests appreciating the available amenities.<br />',
    sub_catg_text: {
      restaurant:
        'Our restaurant is a guest favorite, with {Amenities_restaurant_per}% enjoying the delicious food.<br />',
      'wi-fi':
        '{Amenities_wi-fi_per}% of guests found the Wi-Fi reliable and fast, ensuring seamless connectivity.<br />',
      parking:
        'Guests love the parking facility, with a satisfaction score of {Amenities_parking_per}%.<br />',
      television:
        'The in-room TV service is well-rated, with {Amenities_television_per}% of guests enjoying entertainment during their stay.<br />',
    },
  },
};
